import { OrganLayout } from "@/components/OrganLayout";
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { LEVEL_COLORS } from "@/lib/organs";
import { SectionTitle, DemoBanner } from "@/components/Shared";

const WORKFLOWS = [
  { id: "wf1", label: "Classificazione automatica fornitori ricorrenti", on: true },
  { id: "wf2", label: "Rilevamento duplicati su ogni documento", on: true },
  { id: "wf3", label: "Aggiornamento liquidità serale da POS e banca", on: true },
  { id: "wf4", label: "Promemoria scadenze contrattuali (30 giorni)", on: true },
  { id: "wf5", label: "Pagamenti assistiti dal sistema (richiede autorizzazione bancaria)", on: false },
  { id: "wf6", label: "Invio automatico giustificativi al fiduciario", on: false },
];

export default function Dna() {
  const [organ, setOrgan] = useState(null);
  const [toggles, setToggles] = useState(Object.fromEntries(WORKFLOWS.map((w) => [w.id, w.on])));

  useEffect(() => {
    api.get("/organs/dna").then((r) => setOrgan(r.data)).catch(() => {});
  }, []);

  return (
    <OrganLayout organId="dna" data-testid="dna-page" description="Il modo specifico in cui questa azienda opera. Il sistema impara, ma non accetta mai alla cieca." controls={<DemoBanner />}>

      <div className="glass rounded-3xl p-5 mb-5 fade-up" data-testid="dna-learning">
        <p className="dad-local-warning">I toggle sottostanti sono locali e non persistiti: non modificano la configurazione del backend.</p>
        <SectionTitle>Come il sistema impara</SectionTitle>
        <div className="flex items-start gap-3 text-sm text-gray-300 leading-relaxed">
          <Sparkles size={16} className="text-cyan-300 shrink-0 mt-0.5" />
          <p>
            Dopo almeno <strong className="text-cyan-200">3 conferme coerenti</strong> per lo stesso fornitore, il sistema propone
            la classificazione precedente con maggiore confidenza. Ogni nuovo documento viene comunque letto e verificato:
            se differisce dallo storico, <strong className="text-cyan-200">il documento attuale ha sempre priorità</strong>.
          </p>
        </div>
      </div>

      {organ && (
        <div className="space-y-4 mb-5">
          {organ.sections.map((s) => (
            <div key={s.title} className="glass rounded-3xl p-5">
              <SectionTitle>{s.title}</SectionTitle>
              <div className="space-y-1">
                {s.items.map((it, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 rounded-2xl px-3 py-2.5"
                    style={it.level ? { borderLeft: `2px solid ${LEVEL_COLORS[it.level]}` } : {}}>
                    <span className="text-sm text-gray-200">{it.label}</span>
                    {it.value && <span className="text-sm text-gray-400 shrink-0">{it.value}</span>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="glass rounded-3xl p-5" data-testid="dna-workflows">
        <SectionTitle>Workflow & automazioni autorizzate</SectionTitle>
        <div className="space-y-1">
          {WORKFLOWS.map((w) => (
            <div key={w.id} className="flex items-center justify-between gap-3 rounded-2xl px-3 py-3">
              <span className="text-sm text-gray-200">{w.label}</span>
              <button
                data-testid={`dna-toggle-${w.id}`}
                onClick={() => setToggles((t) => ({ ...t, [w.id]: !t[w.id] }))}
                className={`w-11 h-6 rounded-full relative transition-colors shrink-0 ${toggles[w.id] ? "bg-cyan-400/80" : "bg-white/10"}`}
                role="switch" aria-checked={toggles[w.id]}>
                <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${toggles[w.id] ? "left-[22px]" : "left-0.5"}`} />
              </button>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-gray-600 mt-3 px-3">Le automazioni che muovono denaro richiedono sempre la tua autorizzazione esplicita.</p>
      </div>
    </OrganLayout>
  );
}
